import { render, staticRenderFns } from "./markt.vue?vue&type=template&id=51068741&scoped=true"
import script from "./markt.vue?vue&type=script&lang=js"
export * from "./markt.vue?vue&type=script&lang=js"
import style0 from "./markt.vue?vue&type=style&index=0&id=51068741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51068741",
  null
  
)

export default component.exports